var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepperDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "1px",
    viewBox: "0 0 61 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CA4B7258-F95D-4D53-86FD-478A6EF9DC5D@0.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-Desktop",
    stroke: "none",
    strokeWidth: 0.3,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "2,3",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SME_Asia_B2C_Desktop_Enter_Date_Picker",
    transform: "translate(-777.000000, -43.000000)",
    stroke: "#B0B7C3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TOP_NAV"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(467.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__-/-Utilities-/-Stepper-/-Neg-/-Future-step",
    transform: "translate(250.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 60.6262626,
    y1: 14.5,
    x2: 122,
    y2: 14.5,
    id: "Line-right"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperDash);
export default __webpack_public_path__ + "static/media/StepperDash.e9474b23756627cb461cd7d9627f939d.svg";
export { ForwardRef as ReactComponent };